import crud from '@/crud/index/index'
import resources from '../../resources'

import data from './data'
import methods from './methods'

export default {
  data,
  methods,
  mixins: [crud, resources],
  resourcePath: 'v1/professional/companies/employees'
}



// WEBPACK FOOTER //
// ./src/app/professional/company/employees/index/resources/index.js